import script from "./MasterData.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterData.vue?vue&type=script&setup=true&lang=js"

import "./MasterData.vue?vue&type=style&index=0&id=198722ed&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198722ed"]])

export default __exports__